import { createSlice } from '@reduxjs/toolkit';
import { FileViewerModes } from './FileViewerDialog.constants';
import { resetAllSlices } from '../../Providers/mainStore.slice';

const initialState = {
  open: false,
  mode: FileViewerModes.VISIBLE_ONLY,
  docInfo: null,
};

const fileViewerDialogSlice = createSlice({
  name: 'fileViewerDialog',
  initialState,
  reducers: {
    openFileViewerDialogInVisibleOnlyMode: (state, action) => {
      const { docInfo, fullScreen = false } = action.payload;
      state.open = true;
      state.mode = FileViewerModes.VISIBLE_ONLY;
      state.fullScreen = fullScreen;
      state.docInfo = docInfo;
    },
    openFileViewerDialogInSignableMode: (state, action) => {
      const { docInfo, fullScreen = false } = action.payload;
      state.open = true;
      state.mode = FileViewerModes.SIGNABLE;
      state.fullScreen = fullScreen;
      state.docInfo = docInfo;
    },
    resetFileViewerDialogState: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetAllSlices, () => {
      return initialState;
    });
  },
});

export const {
  openFileViewerDialogInVisibleOnlyMode,
  openFileViewerDialogInSignableMode,
  resetFileViewerDialogState,
} = fileViewerDialogSlice.actions;

export default fileViewerDialogSlice.reducer;
